export const CALCULATE_HABERES = "CALCULATE_HABERES";
export const CALCULATE_HABERES_SUCCESS = "CALCULATE_HABERES_SUCCESS";

export default {
    CALCULATE_HABERES,
    CALCULATE_HABERES_SUCCESS
}
